import noAccessImg from "../../assets/images/noOrderAccess.svg";
import Button from "../Button/Button";
import "./NoAccess.scss";

interface NoAccessProps {
  onClickHandler: () => void;
  headerText: string;
  descriptionText: string;
  descriptionText2: string;
  buttonLabel: string;
  className?: string;
}

const NoAccess = ({ onClickHandler, headerText, descriptionText, descriptionText2, buttonLabel, className = "" }: NoAccessProps) => {
  return (
    <div className={`admin-no-access-section ${className}`}>
      <img src={noAccessImg} alt="No Access Content" />
      <div>
        <p>{headerText}</p>
        <p className="suggestion-text">
          {descriptionText}
        </p>
        <p className="suggestion-text">
          {descriptionText2}
        </p>
      </div>
      <Button
        variant="primary"
        className="admin-no-access-btn"
        onClickHandler={onClickHandler}
        label={buttonLabel}
      />
    </div>
  );
};

export default NoAccess;
